(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/components/draw-picker.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/components/draw-picker.js');

'use strict';

const DatePicker = svs.ui.ReactDatePicker;
const {
  useState,
  useEffect,
  useCallback
} = React;
const {
  useAtom,
  useAtomValue,
  useSetAtom
} = jotai;
const {
  unstable_batchedUpdates
} = ReactDOM;
const {
  useHistory,
  useParams,
  useLocation
} = ReactRouterDOM;
const {
  selectedResultAtom,
  selectedSpanResultsAtom,
  shouldShowIntervalAtom,
  correctionStepAtom
} = svs.lyckoplatsen.components.shared_result.jotai.atoms;
const {
  memoFetchNewDates,
  formatAvailableDates,
  memoFetchResult
} = svs.lyckoplatsen.utils.page_result;
const {
  CONSTANTS: {
    CORRECTION_STEP,
    RESULT_INTERVALS
  }
} = svs.lyckoplatsen.components.shared_constants;
const {
  productMapping
} = svs.lyckoplatsen.components.shared_constants;
const {
  format,
  getISOWeek,
  locales: {
    sv
  }
} = dateFns;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const {
  DrawPickerTopButtons
} = svs.lyckoplatsen.components.page_result.react.components;

const currentActiveDateDraws = jotai.atom({}); 

const DrawPicker = () => {
  const history = useHistory();
  const location = useLocation();
  const {
    dateString
  } = useParams();
  const [currentDrawPickerDraws, setCurrentActiveDate] = useAtom(currentActiveDateDraws) || {}; 

  let initialYear;
  let initialMonth;
  if (dateString && !Object.values(RESULT_INTERVALS).includes(dateString)) {
    [initialYear, initialMonth] = dateString.split('-');
  } else {
    initialYear = dateFns.getYear(new Date());
    initialMonth = dateFns.getMonth(new Date()) + 1;
  }
  const [selectedResult, setSelectedResult] = useAtom(selectedResultAtom);
  const spanResults = useAtomValue(selectedSpanResultsAtom);
  const [shouldShowInterval, setShouldShowInterval] = useAtom(shouldShowIntervalAtom);
  const setCorrectionStep = useSetAtom(correctionStepAtom);
  const [currentMonthYear, setCurrentMonthYear] = useState({
    month: initialMonth,
    year: initialYear
  });
  const [isOpen, setIsOpen] = useState(false);
  const [prevPathname, setPrevPathname] = useState();
  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);
  useEffect(() => {
    (async () => {
      const fetchedDates = await memoFetchNewDates(currentMonthYear.year, currentMonthYear.month);
      if (fetchedDates) {
        unstable_batchedUpdates(() => {
          setCurrentActiveDate(formatAvailableDates(fetchedDates) || {});
        });
      }
    })();
  }, [currentMonthYear, setCurrentActiveDate]);
  const onMonthChange = async _ref => {
    let {
      activeStartDate
    } = _ref;
    const month = dateFns.getMonth(activeStartDate) + 1;
    const year = dateFns.getYear(activeStartDate);
    setCurrentMonthYear({
      month,
      year
    });
  };
  const updateSelectedResultAndStep = useCallback(result => {
    unstable_batchedUpdates(() => {
      var _svs$lyckoplatsen$dat;
      setShouldShowInterval(false);
      if (!isSelfService && result.drawNumber === ((_svs$lyckoplatsen$dat = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat === void 0 ? void 0 : _svs$lyckoplatsen$dat.result_latest.drawNumber)) {
        const startStep = productMapping.isLyckoplatsenPrimary(result.productId) ? CORRECTION_STEP.TOPWIN : CORRECTION_STEP.PLACE;
        setCorrectionStep(startStep);
      } else {
        setCorrectionStep(CORRECTION_STEP.RESULT);
      }
      setSelectedResult(result);
    });
  }, [setShouldShowInterval, setCorrectionStep, setSelectedResult]);
  const handleDateFromUrl = useCallback(async pathname => {
    if (!currentDrawPickerDraws || Object.keys(currentDrawPickerDraws).length === 0) {
      return;
    }
    const match = pathname.match(/\/resultat\/(\d{4}-\d{2}-\d{2})/);
    if (match) {
      const date = new Date(match[1]);
      const draw = Object.values(currentDrawPickerDraws || {}).flatMap(resultDates => resultDates).find(item => dateFns.isSameDay(new Date(item.date), date));
      if (draw) {
        const result = await memoFetchResult(draw.product, draw.drawNumber);
        if (result) {
          unstable_batchedUpdates(() => {
            updateSelectedResultAndStep(result);
          });
        }
      }
    } else {
      unstable_batchedUpdates(() => {
        var _svs$lyckoplatsen$dat2;
        updateSelectedResultAndStep((_svs$lyckoplatsen$dat2 = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat2 === void 0 ? void 0 : _svs$lyckoplatsen$dat2.result_latest);
      });
    }
  }, [currentDrawPickerDraws, updateSelectedResultAndStep]);
  useEffect(() => {
    if ((!prevPathname || prevPathname !== location.pathname) && !shouldShowInterval) {
      handleDateFromUrl(location.pathname);
      setPrevPathname(location.pathname);
    }
  }, [location.pathname, handleDateFromUrl, prevPathname, shouldShowInterval]);
  const onDateChange = async date => {
    handleClose();
    if (!date || !currentDrawPickerDraws || Object.keys(currentDrawPickerDraws).length === 0) {
      return;
    }
    const draw = Object.values(currentDrawPickerDraws || {}).flatMap(resultDates => resultDates).find(item => dateFns.isSameDay(new Date(item.date), new Date(date)));
    if (draw) {
      const result = await memoFetchResult(draw.product, draw.drawNumber);
      if (result) {
        unstable_batchedUpdates(() => {
          updateSelectedResultAndStep(result);
          history.push("/resultat/".concat(dateFns.format(date[0], 'yyyy-MM-dd')));
        });
      }
    }
  };
  const isResultDate = date => Object.values(currentDrawPickerDraws || {}).flatMap(resultDates => resultDates).some(item => dateFns.isSameDay(new Date(item.date), date));
  let selectedDate = new Date((selectedResult === null || selectedResult === void 0 ? void 0 : selectedResult.regCloseTime) || Date.now());
  let externalInputValue = "".concat(format(selectedDate, 'EEEE, d/M', {
    locale: sv
  }), " (v").concat(getISOWeek(selectedDate), ")");
  if (shouldShowInterval) {
    var _spanResults$span, _spanResults$span2;
    const startDate = new Date(spanResults === null || spanResults === void 0 || (_spanResults$span = spanResults.span) === null || _spanResults$span === void 0 ? void 0 : _spanResults$span.startDate);
    const endDate = new Date(spanResults === null || spanResults === void 0 || (_spanResults$span2 = spanResults.span) === null || _spanResults$span2 === void 0 ? void 0 : _spanResults$span2.endDate);
    externalInputValue = "".concat(format(startDate, 'd/M yyyy'), " - ").concat(format(endDate, 'd/M yyyy'));
    selectedDate = null;
  }
  return React.createElement("div", {
    className: "lp-draw-picker"
  }, React.createElement(DatePicker, {
    branding: "tur",
    value: [selectedDate],
    onSet: onDateChange,
    isOpen: isOpen,
    onOpen: handleOpen,
    maxDate: new Date(),
    minDetail: "month",
    externalInputValue: externalInputValue,
    onActiveStartDateChange: onMonthChange,
    tileClassName: _ref2 => {
      let {
        date
      } = _ref2;
      return isResultDate(date) ? 'result-date' : null;
    },
    tileDisabled: _ref3 => {
      let {
        date
      } = _ref3;
      return !isResultDate(date);
    },
    openWithButton: true,
    popupPosition: "center",
    activeStartDate: new Date(currentMonthYear.year, currentMonthYear.month - 1),
    topComponent: React.createElement(DrawPickerTopButtons, {
      handleClose: handleClose
    })
  }), React.createElement("div", {
    className: "lp-draw-picker-overlay ".concat(isOpen ? 'show' : ''),
    onClick: handleClose
  }));
};
Object.assign(svs.lyckoplatsen.components.page_result.react.components, {
  DrawPicker
});

 })(window);